module.exports = __webpack_public_path__ + "static/media/slide-5.bb9f49bb.jpg";